<template>
  <div class="eno-main-page" ref="mainScrollContainer">
    <router-view :key="$route.fullPath"/>
    <enoFooter></enoFooter>
  </div>
</template>

<script>
import enoFooter from '../footer/footer'

export default {
  name: 'mainPage',
  components: {enoFooter},
  data() {
    return {}
  },
  watch: {
    $route(route) {
      this.resetScrollTop(route)
    }
  },
  mounted() {
    // this.resetScrollTop()
  },
  methods: {
    resetScrollTop(route) {
      const scrollTop = route?.query?.scrollTop || 0
      // 延迟确保页面渲染完成
      setTimeout(() => {
        const scrollContainer = this.$refs.mainScrollContainer
        if (scrollContainer) {
          scrollContainer.scrollTop = scrollTop
        }
      }, 100)
    }
  },

}
</script>

<style lang="less">
.eno-main-page {
  max-height: calc(100vh - 72px);
  width: 100vw;
  overflow-y: auto;
  @scrollBarSingle();
}

</style>